export const genWhatsappMessage = (phoneNumber, message) => {
  const messageEncoded = encodeURIComponent(message)
  const url = `https://wa.me/${phoneNumber.replace(/ /g,'')}?text=${messageEncoded}`
  window.open(url, '_blank')
}